
$('.b-sl-text__sl-slick').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
})


// WEBPACK FOOTER //
// ./src/js/pages/object/sl.js